var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconFooterFixedX = function SvgIconFooterFixedX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    fillRule: "evenodd",
    d: "M6.667 8.42 1.19 1.451h4.338L8.91 5.758l3.612-4.286h2.389L10.064 7.23l5.746 7.319h-4.325l-3.66-4.657-3.909 4.644H1.514l5.153-6.117Zm5.448 4.838L3.85 2.743h1.047l8.255 10.515h-1.037Z",
    clipRule: "evenodd"
  })));
};
export default SvgIconFooterFixedX;